import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

// Create an axios instance with credentials
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  withCredentials: true,
  timeout: 180000, // 3 minutes to match server timeouts + buffer
  headers: {
    'Content-Type': 'application/json'
  }
});

export function AnalysisForm() {
  const navigate = useNavigate();
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const response = await api.post('/api/screenshot', { url });
      const { analysisId } = response.data;
      navigate(`/analysis/${analysisId}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to capture screenshot. Please try again.');
      console.error('Screenshot error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto mb-16">
        <div className="flex flex-col md:flex-row gap-4">
          <Input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter website URL..."
            className="flex-1 h-14 text-lg bg-[#1A1A1A] border-[#333] text-white placeholder:text-white placeholder:text-lg"
            required
          />
          <Button 
            type="submit" 
            size="lg"
            disabled={loading}
            className="h-14 px-8 bg-white hover:bg-gradient-to-r from-orange-500 to-pink-500 hover:animate-gradient-x text-black text-lg font-medium transition-all duration-300 group"
          >
            {loading ? 'Processing...' : (
              <>
                Scan Page <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </>
            )}
          </Button>
        </div>
      </form>
      {error && <p className="error-message">{error}</p>}
    </>
  );
} 